import styled from 'styled-components';

const defaultFont =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';

const helveticaNeueFont = 'HelveticaNeue';

export const Container = styled.div`
  width: 100%;
  padding: 20px;
  justify-content: center;
  align-content: center;
  height: ${props => props.height || `80vh`};
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* margin: 0 100px 0 0; */
`;

export const Heading = styled.h1`
  font-size: 45px;
  font-weight: 500;
  margin: 0;
  padding: 0 0 20px 0;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ActionText = styled.span`
  font-size: 18px;
  font-weight: 500;
`;

export const RetryButton = styled.button`
  font-size: 24px;
  margin-bottom: 20px;
  font-weight: 500;
`;
